import { useCallback, ReactElement } from 'react'
import { noop } from 'lodash'
import NavItem from './NavItem'
import { createLogger } from '@utils/logger'

const log = createLogger('useNavLogic', { prependScope: true })
log.setLevel('info')

type NavItemType = {
  identifier?: string | null
  label?: string
  [key: string]: any // Allow for other props that NavItem accepts
}

interface UseNavLogicProps {
  items: NavItemType[]
  section?: string | null
  itemClass?: string
  onNavigate: (idOrIndex: string | number) => void
}

export function useNavLogic({
  items = [],
  section = null,
  itemClass = 'tabbed-nav__list-item',
  onNavigate = noop,
}: UseNavLogicProps) {
  const handleTabClick = useCallback(
    (idOrIndex: string | number) => {
      onNavigate(idOrIndex)
    },
    [onNavigate]
  )

  const getNavItemsContent = useCallback((): ReactElement[] => {
    return items.map((item, index) => {
      const { identifier, ...rest } = item
      const active = section === identifier
      const key = identifier || rest.label || `nav-item-${index}`
      return (
        <NavItem
          key={key}
          active={active}
          className={itemClass}
          onClick={() => handleTabClick(identifier ?? index)}
          {...rest}
        />
      ) as ReactElement
    })
  }, [items, itemClass, section, handleTabClick])

  return {
    handleTabClick,
    getNavItemsContent,
  }
}
